import React from 'react'
import { cn, getTeamPosition, isInTheFirst } from '../../utils/utils'
import Winner from "../../assets/icons/winner.svg";
type Props = {
    currentStage:any
    rowsNumber:number
    previousStage:any
    postion?:'right'|'left'
    baseHight?:number
}

function ResultsColumnCharts({currentStage,rowsNumber,previousStage,postion='left',baseHight=120}: Props) {
    const getWinnerInfo = (data: any,winnerPosition:'up'|'down'='up') => {
 

  const winnerIndex = data?.team_line_ids?.findIndex(
    (item: any,index:number) => item.team_id.id === data?.winner?.id
    
  );
    const winner = data?.team_line_ids?.[winnerIndex]

  
  const winnerName =  winner?.team_id.name
  const winnerId = data?.winner?.id
  const WinnerScore = {
    score_1: winner?.score_1,
    score_2: winner?.score_2,
    score_3: winner?.score_3,
  };
  return { winnerName, WinnerScore,winnerIndex,winnerId };
};


const getLoserInfo =(data: any) => {

  const loser = data?.team_line_ids?.find(
    (item: any) => item.team_id.id !== data?.winner?.id
  );

  const loserName =  loser?.team_id.name
  const loserScore = {
    score_1: loser?.score_1,
    score_2: loser?.score_2,
    score_3: loser?.score_3,
  };
  return { loserName, loserScore };
};
  return (
    <div className="col-span-1   flex flex-col justify-around items-center gap-1 font-bold text-lg text-primary dark:text-white">
              {currentStage &&
                new Array(rowsNumber).fill(0).map((item:any,index:number)=>{
                  const match = currentStage?.[index];
   // if (!match?.winner?.id) return null;

    const topPhase = previousStage[index * 2];
    const bottomPhase = previousStage[index*2 +1];
    console.log(previousStage);
    
    const winnerInfo = getWinnerInfo(match);
    const loserInfo = getLoserInfo(match);

    const topIsFirst = isInTheFirst(getWinnerInfo(topPhase)?.winnerId, match);
  
    const bottomIsFirst = isInTheFirst(getWinnerInfo(bottomPhase)?.winnerId, match);

    const renderScores = (phase: any) => {
      const winnerIdx = winnerInfo?.winnerIndex;
      const position = getTeamPosition(phase?.winner?.id, match);
      const isWinnerTop = winnerIdx === position;

      const score = isWinnerTop ? winnerInfo?.WinnerScore : loserInfo?.loserScore;

      return (
        <>
          <li>{score?.score_1}</li>
          {parseInt(match?.set_per_match) !== 1 && (
            <>
              <li className="font-sans">-</li>
              <li>{score?.score_2}</li>
              <li className="font-sans">-</li>
              <li>{score?.score_3}</li>
            </>
          )}
          <li>
            {isWinnerTop && (
              <img loading="lazy" src={Winner} alt="Winner" width={15} height={15} />
            )}
          </li>
        </>
      );
    };

    return (
      <div key={index} className={cn(" min-h-[170px] border border-secondary w-full  rounded-md  relative text-sm",postion==='right'?"border-r-0 rounded-r-none":"border-l-0 rounded-l-none")} style={{
        height:`${baseHight/rowsNumber}vh`
      }}>
        {/* Top */}
        <p className={cn("absolute top-0",postion==='left'?"left-1":"right-1")}>
         
          {getWinnerInfo(topPhase)?.winnerName}
        </p>
        <ul className={cn("absolute -top-8 flex items-center text-[#747474]  font-digital gap-1 text-lg",postion==='left'?"left-2":"right-2")}>
          {renderScores(topPhase)}
        </ul>

        {/* Bottom */}
        <p className={cn("absolute ",postion === 'left'?'left-1':'right-1')} style={{
          top:`calc(100% + 4px)`
        }}>
          {getWinnerInfo(bottomPhase)?.winnerName}
        </p>
        <ul className={cn("absolute bottom-0 flex items-center text-[#747474]  font-digital gap-1 text-lg",postion === 'left'?'left-2':'right-2')}>
          {renderScores(bottomPhase)}
        </ul>
      </div>
    );
                })}
            </div>
  )
}

export default ResultsColumnCharts